import React, { useState } from 'react';
import './TagModal.css';

export function TagModal({ show, onClose, onAddTag, onDeleteTag, existingTags = [] }) {
  const [newTag, setNewTag] = useState('');

  const handleAddTag = () => {
    if (newTag.trim()) {
      onAddTag(newTag.trim());
      setNewTag('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddTag();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Hantera etiketter</h3>
          <button 
            className="close-button"
            onClick={onClose}
            type="button"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        {/* Existing tags section */}
        {existingTags.length > 0 && (
          <div className="existing-tags">
            <div className="tags-list">
              {existingTags.map((tag) => (
                <div key={tag} className="tag-item">
                  <span>{tag}</span>
                  <button
                    type="button"
                    className="delete-tag-button"
                    onClick={() => onDeleteTag(tag)}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Add new tag form */}
        <form onSubmit={handleSubmit}>
          <div className="input-wrapper">
            <input
              type="text"
              value={newTag}
              onChange={(e) => setNewTag(e.target.value)}
              placeholder="Skapa ny etikett"
              className="tag-input"
            />
            {newTag.trim() && (
              <button
                type="button"
                className="return-button"
                onClick={handleAddTag}
              >
                <i className="fas fa-level-down-alt fa-rotate-90"></i>
              </button>
            )}
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="submit-button">
              Spara
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 